import { handleActions } from 'redux-actions';
import { TimezoneDetails, ReportType, Language } from 'types';
import {
    ServerDetailsRequestAction, ServerDetailsSuccessAction, ServerDetailsFailureAction,
} from 'actions/serverActions';

export type State = Readonly<{
    appVersion: string;
    devicePackVersion: string;
    copyrightYear: number;
    loading: boolean;
    error: Error | null;
    timezone: Readonly<TimezoneDetails> | null;
    reportsPath: string;
    reportsProtocol: 'http' | 'https';
    reportsPort: number;
    reportTypes: ReportType[];
    refreshRate: number; // Refresh rate (in seconds) of updates to content including timeline and alarms
    availableLanguages: ReadonlyArray<Language> | null;
    useWebsocket: boolean;
    features: {[key: string]: boolean};
}>;

export const initialState = Object.freeze<State>({
    appVersion: '',
    devicePackVersion: '',
    copyrightYear: 0,
    loading: false,
    error: null,
    timezone: null,
    reportsPath: '',
    reportsProtocol: 'http',
    reportsPort: 50000,
    reportTypes: [],
    refreshRate: 5,
    availableLanguages: null,
    useWebsocket: false,
    features: {},
});

export type ReducerAction =
    ServerDetailsRequestAction
    | ServerDetailsSuccessAction
    | ServerDetailsFailureAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

export const serverReducer: Reducer = handleActions({
    SERVERDETAILS_REQUEST(state: State, action: ServerDetailsRequestAction) {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    SERVERDETAILS_SUCCESS(state: State, action: ServerDetailsSuccessAction) {
        return {
            ...state,
            ...action.payload,
            loading: false,
            error: null,
        };
    },

    SERVERDETAILS_FAILURE(state: State, action: ServerDetailsFailureAction) {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/serverReducer.ts